import { useState } from "react";
import { T } from "react-translator-component";
import { Box, Button } from "@mui/material";
import PostReportModal from "../PostReportModal";

interface Props {
  post: any;
  postReports?: any[];
  onChangePostReports?: () => void;
}

export default function UserPostsHeader({ post, postReports = [], onChangePostReports }: Props) {
  const [showPostReportModal, setShowPostReportModal] = useState<boolean>(false)

  const isPostReported = () => {
    if (!postReports || postReports.length === 0) return false
    return postReports.some((postReport: any) => postReport.post_id === post.id)
  };

  return (
    <>
      <Box sx={styles.container}>
        <Button
          style={styles.button}
          onClick={() => setShowPostReportModal(true)}
          color={"secondary"}
          variant="text"
          disabled={isPostReported()}
        >
          {T("mng_report")}
        </Button>
      </Box>

      <PostReportModal
        open={showPostReportModal}
        post={post}
        onCompleted={onChangePostReports}
        onClose={() => setShowPostReportModal(false)}
      />
    </>
  );
}

const styles = {
  container: {
    display: "flex"
  },
  button: { fontSize: 12 }
};
